<template>
  <div>
    <vxe-card>
      <div slot="title">
        <vxe-button content="tab.details" icon="vxe-icon-arrows-left" mode="text" status="primary" @click="back"/>
      </div>
      <template #extra>
        <vxe-button :disabled="field.isNew()" content="button.refresh" icon="vxe-icon-refresh" mode="text" status="danger" @click="refresh(field.id)"/>
        <vxe-button content="button.add" icon="vxe-icon-add" mode="text" status="primary" @click="add"/>
      </template>
      <vxe-table ref="table" :data="dictionaries" :loading="loading" @cell-click="({row})=>click(row)">
        <vxe-column fixed="left" type="seq" width="40"/>
        <vxe-column field="no" title="business.label.no" width="150"/>
        <vxe-column field="name" title="business.label.name" width="300"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="available" title="business.label.available" width="70"/>
        <vxe-column field="ordinal" title="business.label.ordinal" width="60"/>
        <vxe-column field="value" title="business.label.dictionaryValue"/>
        <vxe-column :formatter="({row})=>getStrings(row.enterprises,'name')" field="enterprises" title="business.label.enterprise" width="100"/>
        <vxe-column :formatter="({row})=>getStrings(row.warehouses,'name')" field="warehouses" title="business.label.warehouse" width="100"/>
        <vxe-column fixed="right" title="business.label.operate" width="auto">
          <vxe-button-group slot-scope="{row}" mode="text">
            <vxe-button content="button.edit" icon="vxe-icon-edit" status="primary" @click.stop="edit(row,false)"/>
            <vxe-button content="button.copy" icon="vxe-icon-copy" status="primary" @click.stop="edit(row,true)"/>
          </vxe-button-group>
        </vxe-column>
      </vxe-table>
    </vxe-card>
    <DictionaryEditor ref="editor" @success="refresh(field.id)"/>
    <direction-config v-if="field.no==='DIRECTION'" ref="directionConfig"/>
  </div>
</template>

<script>
import { findOne } from '@/api/Api'
import { Field } from '@/api/dto/admin/Field'
import { Dictionary } from '@/api/dto/admin/Dictionary'
import { getStrings } from '@/utils/util'
import DictionaryEditor from '@/views/config/dictionary/DictionaryEditor.vue'
import DirectionConfig from '@/views/config/dictionary/configs/DirectionConfig.vue'

export default {
  name: 'DictionaryDetail',
  components: { DictionaryEditor, DirectionConfig },
  data() {
    return {
      loading: false,
      field: new Field(),
      dictionaries: [],
      labelCol: { span: 8 },
      wrapperCol: { span: 16 }
    }
  },
  methods: {
    getStrings,
    back() {
      this.$emit('back')
    },
    refresh(id) {
      findOne('fieldFactory', { id: id }).then(res => {
        if (res.success) {
          this.field = new Field(res.result)
          this.dictionaries = res.result.dictionaries.map(item => {
            return new Dictionary(item)
          })
        }
      })
    },
    add() {
      this.$refs.editor.add(this.field)
    },
    edit(row, copy) {
      this.$refs.editor.edit(this.field, row, copy)
    },
    click(row) {
      if (this.field.no === 'DIRECTION') {
        this.$refs.directionConfig.direction = new Dictionary(row)
        this.$refs.directionConfig.refresh()
      }
    }
  }
}
</script>